import * as types from 'model/actionTypes'
import { DictT, TourModelT } from 'types/model'

export function receiveTourModels (tourModels: DictT<TourModelT>) {
  return {
    type: types.RECEIVE_TOUR_MODELS,
    tourModels
  }
}
